import { Component, Input, OnInit } from '@angular/core';
import { TransportDetail } from '../../gantt-chart.model';
import { GanttChartWidget } from '../gantt-chart/gantt-chart.component';

@Component({
  selector: 'app-transport-row',
  templateUrl: './transport-row.component.html',
  styleUrls: ['./transport-row.component.scss']
})
export class TransportRowComponent implements OnInit {

  @Input() transports: Array<TransportDetail>;

  @Input() selectedTransportId: number;

  @Input() ganttChart: GanttChartWidget;

  @Input() scale: number;

  @Input() offsetBefore: number;

  constructor() { }

  ngOnInit(): void {
  }

  selectTransport(transportId: number) {
    this.ganttChart.selectTransport(transportId);
  }

}
